import { render, staticRenderFns } from "./similarProducts.vue?vue&type=template&id=e192f4d0&"
import script from "./similarProducts.vue?vue&type=script&lang=js&"
export * from "./similarProducts.vue?vue&type=script&lang=js&"
import style0 from "./similarProducts.vue?vue&type=style&index=0&id=e192f4d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports